export const VERSION_LEGACY = 'version-legacy';
export const VERSION_UIKIT = 'version-uikit';
export const VERSION_UIKIT_RESPONSIVE = 'version-uikit-responsive';

export const TYPE_CHECKBOX = 'checkbox';
export const TYPE_RADIO = 'radio';
